import React, { useEffect, useState } from 'react'
import { Autocomplete, FormControl, TextField } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import { getPredictionModels, getPredictionModelById } from './services'

interface Props {
  readonly onPredictionModelChange: (id: number | null) => void
  readonly predictionModelId?: number | null
  readonly disabled?: boolean
  readonly required?: boolean
  readonly error?: boolean
}

export default function FilterAutocompletePredictionModel({
  onPredictionModelChange,
  predictionModelId,
  disabled = false,
  required = false,
  error = false,
}: Props) {
  const { translate } = useLang()
  const [options, setOptions] = useState<ReadonlyArray<{ readonly id: number; readonly name: string }>>([])
  const [value, setValue] = useState<{ readonly id: number; readonly name: string } | null>(null)

  useEffect(() => {
    getPredictionModels().then((list) => setOptions(list)).catch(() => setOptions([]))
  }, [])

  useEffect(() => {
    if (!predictionModelId) {
      setValue(null)
    } else {
      getPredictionModelById(predictionModelId).then((res) => setValue(res)).catch(() => setValue(null))
    }
  }, [predictionModelId])

  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        id="filter-prediction-model"
        options={options}
        disabled={disabled}
        value={value}
        noOptionsText={translate('No options')}
        size="small"
        isOptionEqualToValue={(option, val) => option?.id === val?.id}
        getOptionLabel={(option) => option?.name ?? ''}
        onChange={(_, model) => {
          setValue(model ?? null)
          onPredictionModelChange(model?.id ?? null)
        }}
        renderInput={(params) => (
          <TextField 
            {...params} 
            label={translate('Prediction model')} 
            required={required}
            error={error}
          />
        )}
      />
    </FormControl>
  )
}
